import { useState } from "react";
import Checkbox from "./Checkbox"

export default function PolicyContents(props) {
    const {
        className = "",
        styles = {},
        checked = false,
        setChecked = () => { },
        companyName = "상호"
    } = props

    const [quetion_check, setquetion_check] = useState([]);
    const [isDetail, setIsDetail] = useState(false);

    const selFontSize = 11;

    return <div className={className} style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        ...styles
    }}>
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            height: 40,
            alignItems: "center"
        }}>
            <Checkbox
                linetype={'checkimg'}
                values={quetion_check}
                setvalues={(e) => {
                    if (e.find(v => v.values === 1)) {
                        setChecked(true)
                    } else {
                        setChecked(false)
                    }
                    setquetion_check(e)
                }}
                namevalue={[
                    { names: <b>(필수) 개인정보 수집ㆍ이용 및 제3자 제공에 동의합니다.</b>, values: 1 },
                ]}
                fontweights={400}
                fontSizes={14}
                sizes={20}
            />
            <button onClick={() => {
                setIsDetail(v => !v);
            }}>
                {
                    isDetail ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.41075 6.07742C9.73619 5.75198 10.2638 5.75198 10.5893 6.07742L16.4226 11.9108C16.748 12.2362 16.748 12.7638 16.4226 13.0893C16.0972 13.4147 15.5695 13.4147 15.2441 13.0893L10 7.84519L4.75593 13.0893C4.4305 13.4147 3.90286 13.4147 3.57742 13.0893C3.25198 12.7638 3.25198 12.2362 3.57742 11.9108L9.41075 6.07742Z" fill="#666666" />
                        </svg> :
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.57742 6.91073C3.90286 6.5853 4.4305 6.5853 4.75593 6.91073L10 12.1548L15.2441 6.91073C15.5695 6.5853 16.0972 6.5853 16.4226 6.91073C16.748 7.23617 16.748 7.76381 16.4226 8.08925L10.5893 13.9226C10.2638 14.248 9.73619 14.248 9.41075 13.9226L3.57742 8.08925C3.25198 7.76381 3.25198 7.23617 3.57742 6.91073Z" fill="#666666" />
                        </svg>
                }
            </button>
        </div>
        {isDetail && <div>
            <p style={{ marginTop: 20, fontSize: 12 }}>에이피링스 주식회사의 중개사 ERP 시스템 모두의매물을 이용중인 <b>{companyName}</b>의 중개서비스를 제공받기 위해서는 다음 개인정보 수집ㆍ이용 및 제3자 제공에 관한 동의가 필요합니다.</p>
            <p style={{ marginTop: 20, fontSize: 12, fontWeight: 700 }}>◼︎ 개인정보 수집ㆍ이용 내역</p>
            <table className='contractTable' style={{
                border: "1px", marginTop: 4
            }}>
                <tr>
                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>수집ㆍ이용 목적</td>
                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>수집 항목</td>
                    <td style={{ width: "calc(100% / 3)", textAlign: "center", fontSize: selFontSize }}>보유ㆍ이용 기간</td>
                </tr>
                <tr>
                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">공인중개사 및 중개보조원 회원의 중개 서비스 제공</td>
                    <td style={{ textAlign: "center", fontSize: selFontSize }}>연락처</td>
                    <td style={{ textAlign: "center", fontSize: selFontSize }}>서비스 목적 달성시까지</td>
                </tr>
            </table>

            <p style={{ marginTop: 20, fontSize: 12, fontWeight: 700 }}>◼︎ 개인정보 제3자 제공 동의</p>
            <table className='contractTable' style={{
                border: "1px", marginTop: 4
            }}>
                <tr>
                    <td style={{ width: "25%", textAlign: "center", fontSize: selFontSize }}>제공받는자</td>
                    <td style={{ width: "20%", textAlign: "center", fontSize: selFontSize }}>제공 항목</td>
                    <td style={{ width: "30%", textAlign: "center", fontSize: selFontSize }}>제공 목적</td>
                    <td style={{ width: "25%", textAlign: "center", fontSize: selFontSize }}>보유ㆍ이용 기간</td>
                </tr>
                <tr>
                    <td style={{ textAlign: "center", fontSize: selFontSize, wordBreak: 'break-all' }} className="bolds">{companyName}</td>
                    <td style={{ textAlign: "center", fontSize: selFontSize }}>연락처</td>
                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">이용자의 요청에 따른 중개 서비스 및 상담</td>
                    <td style={{ textAlign: "center", fontSize: selFontSize }} className="bolds">서비스 목적 달성시까지</td>
                </tr>
            </table>
            <p style={{ marginTop: 10, fontSize: 10 }}><b>✻</b> 위와 같이 개인정보를 제공하는데 동의를 거부할 권리가 있습니다.</p>
            <p style={{ fontSize: 10 }}>그러나 동의를 거부할 경우 담당 중개사 및 중개보조원의 중개서비스 제공을 받으실 수 없습니다.</p>
        </div>}

    </div>
}